export default __webpack_public_path__ + "locales/si/FormFillingTipsDialog.json?hash=655acd54d4cfa8a94922e6731c1fd61c";